export default "__VITE_ASSET__D0jAh1Wu__"